import Http from '../../http/client';

export default async (phoneNumber) => {
  const response = await Http.post('auth/login', {
    phoneNumber,
    gateway: "ADMIN",
    language: "tr"
  });

  return response.data;
}
